import { css } from 'aphrodite';
import { withAuthenticationRequired } from 'react-oidc-context';

import { DefaultLayout } from './layout/DefaultLayout';
import stylesCommons from './StylesCommons';

function WelcomePage() {
    return (
        <DefaultLayout>
            <div className={css(stylesCommons.content)}>
                <h1>Welcome to User Admin</h1>
                <h2>If you reset the password then the process was successful.</h2>
                <h2>If not please ignore this message.</h2>
            </div>
        </DefaultLayout>
    );
}

export default withAuthenticationRequired(WelcomePage, {
    OnRedirecting: () => <div>Redirecting to the login page...</div>,
});
